/**
 * WoodTrayShop.com - Theme Scripts
 * Provides mobile menu, cookie consent, cart drawer, product gallery, and accordion interactions.
 */

document.addEventListener('DOMContentLoaded', () => {
  // Fix document title on any policy paths if needed
  const pathname = window.location.pathname.toLowerCase();
  if (pathname.includes('privacy')) {
    document.title = 'Privacy Policy \u2013 WoodTrayShop.com';
  } else if (pathname.includes('shipping') || pathname.includes('delivery')) {
    document.title = 'Shipping & Delivery Policy \u2013 WoodTrayShop.com';
  } else if (pathname.includes('return') || pathname.includes('refund')) {
    document.title = 'Returns & Refunds Policy \u2013 WoodTrayShop.com';
  } else if (pathname.includes('terms') || pathname.includes('condition')) {
    document.title = 'Terms & Conditions \u2013 WoodTrayShop.com';
  } else if (pathname.includes('cookie')) {
    document.title = 'Cookie Policy \u2013 WoodTrayShop.com';
  } else if (pathname.includes('faq')) {
    document.title = 'Frequently Asked Questions \u2013 WoodTrayShop.com';
  } else if (pathname.includes('about')) {
    document.title = 'About Our Artisan Craft \u2013 WoodTrayShop.com';
  } else if (pathname.includes('contact')) {
    document.title = 'Contact Us \u2013 WoodTrayShop.com';
  }

  // 1. Mobile Menu Drawer
  const mobileToggle = document.getElementById('mobileMenuToggle');
  const mobileDrawer = document.getElementById('mobileNavDrawer');
  const mobileOverlay = document.getElementById('mobileDrawerOverlay');
  const closeMobileBtn = document.getElementById('closeMobileDrawer');

  function openMobileMenu() {
    if (mobileDrawer) mobileDrawer.classList.add('active');
    if (mobileOverlay) mobileOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileMenu() {
    if (mobileDrawer) mobileDrawer.classList.remove('active');
    if (mobileOverlay) mobileOverlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  if (mobileToggle) mobileToggle.addEventListener('click', openMobileMenu);
  if (closeMobileBtn) closeMobileBtn.addEventListener('click', closeMobileMenu);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileMenu);

  // 2. Cookie Consent Banner
  const cookieBanner = document.getElementById('cookieConsentBanner');
  const btnAcceptCookies = document.getElementById('btnAcceptCookies');
  const btnNecessaryCookies = document.getElementById('btnNecessaryCookies');

  if (cookieBanner) {
    const consent = localStorage.getItem('woodtrayshop_cookie_consent');
    if (!consent) {
      cookieBanner.style.display = 'block';
    }

    if (btnAcceptCookies) {
      btnAcceptCookies.addEventListener('click', () => {
        localStorage.setItem('woodtrayshop_cookie_consent', 'all');
        cookieBanner.style.display = 'none';
      });
    }

    if (btnNecessaryCookies) {
      btnNecessaryCookies.addEventListener('click', () => {
        localStorage.setItem('woodtrayshop_cookie_consent', 'necessary');
        cookieBanner.style.display = 'none';
      });
    }
  }

  // 3. Cart Drawer Interactions
  const cartButtons = document.querySelectorAll('.js-open-cart');
  const cartDrawer = document.getElementById('cartDrawer');
  const cartOverlay = document.getElementById('cartDrawerOverlay');
  const closeCartBtn = document.getElementById('closeCartDrawer');

  function openCartDrawer() {
    if (cartDrawer) cartDrawer.classList.add('active');
    if (cartOverlay) cartOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    if (cartDrawer) cartDrawer.classList.remove('active');
    if (cartOverlay) cartOverlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  cartButtons.forEach(btn => btn.addEventListener('click', (e) => {
    e.preventDefault();
    openCartDrawer();
  }));

  if (closeCartBtn) closeCartBtn.addEventListener('click', closeCartDrawer);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);

  // 4. Accordion Toggle
  const accordions = document.querySelectorAll('.accordion-trigger');
  accordions.forEach(trigger => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.accordion-item');
      if (item) {
        const isActive = item.classList.contains('active');
        const group = item.closest('.accordion-group');
        if (group) {
          group.querySelectorAll('.accordion-item').forEach(i => i.classList.remove('active'));
        }
        if (!isActive) {
          item.classList.add('active');
        }
      }
    });
  });

  // 5. Product Image Gallery Switching
  const thumbnails = document.querySelectorAll('.product-thumb');
  const mainImage = document.getElementById('productMainImage');

  thumbnails.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbnails.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      const newSrc = thumb.getAttribute('data-img-src');
      if (mainImage && newSrc) {
        mainImage.setAttribute('src', newSrc);
      }
    });
  });

  // 6. Quantity Selector
  const qtyMinus = document.querySelectorAll('.qty-minus');
  const qtyPlus = document.querySelectorAll('.qty-plus');

  qtyMinus.forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('.quantity-input');
      if (input) {
        let val = parseInt(input.value, 10) || 1;
        if (val > 1) {
          input.value = val - 1;
        }
      }
    });
  });

  qtyPlus.forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('.quantity-input');
      if (input) {
        let val = parseInt(input.value, 10) || 1;
        input.value = val + 1;
      }
    });
  });

  // 7. Contact Form Feedback
  const contactForms = document.querySelectorAll('.js-contact-form');
  contactForms.forEach(form => {
    form.addEventListener('submit', (e) => {
      if (!form.getAttribute('action') || form.getAttribute('action') === '#' || form.getAttribute('action').includes('#contact_form')) {
        const successBanner = form.querySelector('.form-success-banner') || document.getElementById('contactSuccessBanner');
        if (successBanner) {
          successBanner.style.display = 'block';
        }
      }
    });
  });
});
